import React, { useState, useEffect, useRef } from 'react'
import { TESTIMONIAL_DATA } from '../helpers/constants'
const delay = 5500

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  const [itemIndex, setItemIndex] = useState(0)
  const timeoutRef = useRef(null)

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }

  useEffect(() => {
    resetTimeout()
    timeoutRef.current = setTimeout(
      () =>
        setItemIndex((prevIndex) =>
          prevIndex === TESTIMONIAL_DATA.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    )
    return () => {
      resetTimeout()
    }
  }, [itemIndex])
  return (
    <div data-type='slideshow'>
      <div
        data-type='slider'
        style={{
          transform: `translate3d(${-itemIndex * 100}%, 0, 0)`,
        }}
      >
        {TESTIMONIAL_DATA.map((item, index) => (
          <div data-type='slide' key={index} data-style={itemIndex === index ? 'active' : ''}>
            <picture data-type='image'>
              <img
                width='1440'
                height='600'
                itemProp='image'
                src={item.image}
                alt='testimonial'
                role='presentation'
                data-type='image'
              />
              <div data-type='content'>
                <p data-type='title'>How artists are finding success with Saatchi Art</p>
                <hr data-type='small-border' />
                <p data-type='comment'>{item.comment}</p>
                <p data-type='user'>{item.user}</p>
                <p data-type='location'>{item.location}</p>
                <div data-type='dots'>
                  {TESTIMONIAL_DATA.map((data, idx) => (
                    <div
                      key={idx}
                      data-type='dot'
                      data-style={itemIndex === idx ? 'active' : ''}
                      onClick={() => {
                        setItemIndex(idx)
                      }}
                      role='button'
                      tabIndex='0'
                      onKeyDown={() => {
                        setItemIndex(idx)
                      }}
                    />
                  ))}
                </div>
              </div>
            </picture>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Component